import React from 'react';
import {SelectBase} from 'components/Forms/FormBases';
import {DAILY_SEARCH_FREQUENCY} from 'configs';

function SelectDailySearchFrequency(props) {
  const {defaultValue, ...rest} = props;

  function getOptions() {
    return Object.entries(DAILY_SEARCH_FREQUENCY).map(([key, value]) => {
      return {value: key, label: value};
    });
  }

  return (
    <SelectBase
      defaultValue={getOptions().filter((item) => item.value === defaultValue)}
      placeholder="Select a daily search frequency"
      options={getOptions()}
      getOptionLabel={(option) => option['label']}
      getOptionValue={(option) => option['value']}
      {...rest}
    />
  );
}

export default SelectDailySearchFrequency;
